import {Bar} from 'react-chartjs-2';
import {BarController, BarElement, CategoryScale, Chart, LinearScale, LineElement, TimeScale, Tooltip} from "chart.js";
import {colors} from "../../theme";
import 'moment/locale/de';

import 'chartjs-adapter-moment';
import {Aggregation} from "../../@types/Query";

Chart.register(CategoryScale, LinearScale, BarElement, LineElement, BarController, Tooltip, TimeScale);

type TimeUnit = Aggregation;

type Props = {
    data: {
        date: Date
        hits: number
    }[]
    timeUnit: TimeUnit
    height?: number
    backgroundColor?: string
}

const tooltipDataFormat: {[key in TimeUnit]: string} = {
    minutes_1: 'HH:mm - dd Do MMM YYYY',
    minutes_5: 'HH:mm - dd Do MMM YYYY ',
    hour: 'HH:mm - dd Do MMM YYYY ',
    day: 'dd Do MMM YYYY',
    month: 'MMMM YYYY',
    year: 'YYYY'
}

const prepositionDates: {[key in TimeUnit]: (date: Date) => Date} = {
    minutes_1: (d) => {
        d.setMilliseconds(0);
        d.setSeconds(0);
        return d;
    },
    minutes_5: (d) => {
        d.setMilliseconds(0);
        d.setSeconds(0);
        return d;
    },
    hour:  (d) => {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        return d;
    },
    day: (d) => {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setHours(0)
        return d;
    },
    month:  (d) => {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        d.setDate(1);
        return d;
    },
    year:  (d) => {
        d.setMilliseconds(0);
        d.setSeconds(0);
        d.setMinutes(0);
        d.setHours(0);
        d.setDate(1);
        d.setMonth(0);
        return d;
    },
}

const BarChart = (
    {
        data,
        timeUnit = "hour",
        height = 500,
        backgroundColor = colors.primary,
    }: Props
) => {
    const prepositionDatesFunction = prepositionDates[timeUnit];
    const chartData = data.map(({date, hits}) => ({x: prepositionDatesFunction(date), y: hits}));

    return (
        <Bar
            height={height}
            data={{
                datasets: [{
                    data: chartData,
                    backgroundColor,
                }]
            }}
            options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: timeUnit == "minutes_5" || timeUnit === "minutes_1" ? "minute": timeUnit,
                            tooltipFormat: tooltipDataFormat[timeUnit],
                            stepSize: timeUnit == "minutes_5" ? 5 : 1,
                            displayFormats: {
                                minute: "HH:mm",
                                hour: "HH",
                                month: "MMM YYYY",
                            },
                        },

                        grid: {
                            display: false,
                        }
                    },
                    y: {
                        beginAtZero: true,
                    },
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                }
            }}
        />
    )
}

export default BarChart